import {FC, ImgHTMLAttributes} from "react";

interface CustomImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  active: boolean;
}

const Image: FC<CustomImageProps> = (props) => {
  const { active, ...rest } = props;

  const handleMouseDown = (e: any) => {
    e.preventDefault();
  }

  return (
    <img
      onMouseDown={handleMouseDown}
      {...rest}
      style={{
        borderRadius: 8,
        border: `2px solid ${active ? 'rgba(132, 250, 176, 1)' : 'transparent'}`,
        transition: 'border 0.3s'
      }}
    />
  )
}

export default Image